import api from '@/store/api/scheduled-report'
import * as mutationTypes from './mutation-types'

const initialState = () => ({
    scheduledReport: {
        name: undefined,
        recipients: [],
        filters: {
            report: undefined,
        },
        runAt: {
            frequency: undefined,
            time: undefined,
            day: undefined,
            date: undefined
        }
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        scheduledReport: state => ({
            ...state.scheduledReport,
            runAt: {
                ...state.scheduledReport.runAt,
                time: state.scheduledReport.runAt.time
            }
        })
    },
    actions: {
        showScheduledReport: async ({commit, dispatch}, {uuid, data}) => {
            try {
                const response = await api.showScheduledReport(uuid, data)
                commit(mutationTypes.SET_SCHEDULED_REPORT, response.report)
                return response.report
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        createScheduledReport: async ({dispatch}, data) => {
            try {
                return await api.createScheduledReport(data)
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        updateScheduledReport: async ({dispatch}, {uuid, data}) => {
            try {
                const response = await api.updateScheduledReport(uuid, data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        removeScheduledReports: async ({dispatch}, data) => {
            try {
                const response = await api.removeReports(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetScheduledReport: async ({commit}) => commit(mutationTypes.RESET_SCHEDULED_REPORT)
    },
    mutations: {
        [mutationTypes.RESET_SCHEDULED_REPORT]: (state) => Object.assign(state, initialState()),
        [mutationTypes.SET_SCHEDULED_REPORT]: (state, data) => state.scheduledReport = data
    }
}
